<template>

  <v-content>

    <v-overlay :value="overlay">

      <v-progress-circular indeterminate size="64"></v-progress-circular>

    </v-overlay>

    <v-snackbar v-model="errorSnackbar" color="error">

      Please fix the error(s) on the form.

      <template v-slot:action="{ attrs }">

        <v-btn text v-bind="attrs" @click="errorSnackbar = false">

          <v-icon>mdi-close-circle</v-icon>

        </v-btn>

      </template>

    </v-snackbar>

    <v-dialog v-model="forgotPasswordDialog" persistent max-width="400">

      <v-card>

        <v-card-title class="text-h5 word-break"><strong>Forgot Password</strong></v-card-title>

        <v-card-text class="text-body-1">

          <p>Please check your email for a link to reset your password.</p>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="forgotPasswordOkDialog" color="primary">ok</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-layout align-center justify-center>

      <v-card elevation="0" class="pb-2" min-width="400px" max-width="450">

        <v-card-title class="text-h5 word-break"><strong>Forgot Password</strong></v-card-title>

        <v-card-text>

          <p>Please enter your email address and click submit to receive a reset password link.</p>

          <v-text-field label="Email" v-model="forgotPasswordInfo.email" type="text" :error-messages="emailErrors" maxlength="100" outlined></v-text-field>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn color="primary" class="mr-2" @click="submit">submit</v-btn>

        </v-card-actions>

      </v-card>

    </v-layout>

  </v-content>

</template>

<script lang="ts">

import Vue from 'vue'

import { required } from "vuelidate/lib/validators";

import axios from "axios";

function validateEmail(value: string | null) {

  return value == null || value == "" || value.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) !== null;

}

export default Vue.extend({

  name: 'Login',

  created()
  {
    // implement security (kick out if needed)

    if (this.$store.state.user.email != null)
    {
      if (this.$route.path != '/Form') this.$router.push('/Form');
    }

  },

  data: () =>
  {
    return {

      overlay: false,

      forgotPasswordInfo: {

        email: ''

      },

      errorSnackbar: false,

      forgotPasswordDialog: false

    };
  },

  methods:
      {
        forgotPasswordOkDialog()
        {
          if (this.$route.path != '/Login') this.$router.push('/Login');
        },

        clearSnackbars() {

          this.errorSnackbar = false;

        },

        async submit() {

          this.$v.forgotPasswordInfo.$touch();

          if (!this.$v.forgotPasswordInfo.$invalid) {

            this.clearSnackbars();

            this.overlay = true;

            setTimeout(async () => {

              let obj = await axios.post('accounts/forgot-password', this.forgotPasswordInfo);

              this.overlay = false

              this.forgotPasswordDialog = true;

            }, 100);

          } else {

            this.errorSnackbar = true;

          }
        }
      },

  validations:
      {
        forgotPasswordInfo:
            {
              email: {

                required,

                validateEmail

              }

            }
      },

  computed:
      {
        emailErrors()
        {
          if (this.$v.forgotPasswordInfo.email && !this.$v.forgotPasswordInfo.email.$dirty) return [];

          if (this.$v.forgotPasswordInfo.email && !this.$v.forgotPasswordInfo.email.required) return ['Email is required.'];

          if (this.$v.forgotPasswordInfo.email && !this.$v.forgotPasswordInfo.email.validateEmail) return ['Email is invalid.'];

          return null;
        }

      }

})

</script>

<style>

.word-break {

  word-break: break-word;

}

.v-messages__message {

  font-size: 14px !important;

}

th > .v-icon {

  color: white !important;

}

</style>
